import DashboardRateCard, { DashboardRateCardProps } from './DashboardRateCard';

export type { DashboardRateCardProps };
export default DashboardRateCard;
